"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _Link.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _theme.AButton;
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});
exports.Card = exports.Image = exports.Heading = exports.Text = exports.Flex = exports.Box = void 0;
var _styledSystem = require("styled-system");
var _extendRebass = require("../extendRebass");
var _Link = _interopRequireDefault(require("./Link/Link"));
var _theme = require("@chatterbug/theme");
var _Grid = _interopRequireDefault(require("./Grid"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var primitives = (0, _extendRebass.extend)({
  Box: [_styledSystem.opacity, _styledSystem.display, _styledSystem.textAlign, _styledSystem.borders, _styledSystem.borderRadius, _styledSystem.boxShadow, _styledSystem.minWidth, _styledSystem.maxWidth, _styledSystem.minHeight, _styledSystem.maxHeight, _styledSystem.height, _styledSystem.gridGap, _styledSystem.gridColumn, _styledSystem.gridRow, _styledSystem.gridTemplateColumns, _styledSystem.gridTemplateRows, _styledSystem.gridTemplateAreas, _styledSystem.gridAutoRows, _styledSystem.height, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundSize, _styledSystem.backgroundRepeat, _styledSystem.position, _styledSystem.left, _styledSystem.right, _styledSystem.top, _styledSystem.bottom],
  Flex: [_styledSystem.alignContent],
  Text: [_styledSystem.textStyle]
});
primitives.Heading.defaultProps = {
  textStyle: 'heading'
};
var Box = primitives.Box,
  Flex = primitives.Flex,
  Text = primitives.Text,
  Heading = primitives.Heading,
  Image = primitives.Image,
  Card = primitives.Card;
exports.Card = Card;
exports.Image = Image;
exports.Heading = Heading;
exports.Text = Text;
exports.Flex = Flex;
exports.Box = Box;